import { AfterViewInit, Component, ElementRef, HostListener, OnInit, Renderer2, ViewChild } from '@angular/core';
import { configuration } from 'src/configuration';
import { SharedService } from '../service/shared.service';
import { ApiServiceService } from '../service/api-service.service';
import { ActivatedRoute, Router } from '@angular/router';
declare var bootstrap: any;
declare var $: any;
import { Observable, catchError, from, map, of, throwError } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-search-property-list',
  templateUrl: './search-property-list.component.html',
  styleUrls: ['./search-property-list.component.css']
})
export class SearchPropertyListComponent implements AfterViewInit, OnInit {
  selectedTab = '';
  priceLimitSelectedOption: string = ''; // Updated type
  SelectedOption: string = '';
  isremarkModal: any = false
  userData: any = {};
  isRemarkModal: any = false
  isViewRemarkModal: any = false
  isView: any = false
  isFilter: any = false
  selectedUser: any = null;
  propertyList: any = [];
  developerList: any = [];
  limit: any = configuration.PAGE_LIMIT;
  offset: any = configuration.OFFSET;
  isPriceLimitRentDropdownOpen: boolean = false;
  isDropdownOpen: boolean = false;
  dropdownValues: string[] = ['20000', '30000', '40000', '50000', '60000', '70000', '80000', '90000', '100000', '110000', '120000', '130000', '140000', '150000', '160000', '170000', '180000', '190000', '200000', '225000', '250000', '275000', '300000', '350000', '400000', '500000', '750000', '1000000'];
  dropdownValues2: string[] = [
    '500', '600', '700', '800', '900',
    '1000', '1100', '1200', '1300', '1400',
    '1500', '1600', '1800', '2000', '2200',
    '2400', '2600', '2800', '3000', '3200',
    '3400', '3600', '3800', '4200', '4600',
    '5000', '5400', '5800', '6200', '6600',
    '7000', '7400', '7800', '8200', '9000'
  ];
  dropdownValuesArea = [
    500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800,
    2000, 2200, 2400, 2600, 2800, 3000, 3200, 3400, 3600, 3800,
    4200, 4600, 4800, 5200, 5400, 5600, 6000, 6400, 6800, 7200, 7400, 7800, 8400, 9000
  ];
  dropdownValuesArea2 = [
    500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800,
    2000, 2200, 2400, 2600, 2800, 3000, 3200, 3400, 3600, 3800,
    4200, 4600, 4800, 5200, 5400, 5600, 6000, 6400, 6800, 7200, 7400, 7800, 8400, 9000
  ];
  propertyTypes: string[] = ['Rent', 'Buy', 'Offplan'];
  dropdownValues3: any = [];
  totalCount = 0;
  currentPage = 1;
  isLoaded = false;
  // dropdownValues3: string[] = ['Apartment', 'Townhouse', 'Villa', 'Villa', 'Penthouse', 'Duplex', 'Bunglow'];

  PropertyTypes = [
    { name: 'Apartments', count: 82984 },
    { name: 'Villas', count: 17849 },
    { name: 'Townhouses', count: 5502 },
    { name: 'Hotel Apartments', count: 802 }
  ];
  PropertyTypes02 = [
    { name: 'Duplexes', count: 653 },
    { name: 'Penthouses', count: 466 },
    { name: 'Compounds', count: 144 },
    { name: 'Whole Buildings', count: 45 },
  ];
  PropertyTypes03 = [
    { name: 'Bungalows', count: 28 },
    { name: 'Bulk Rent Units', count: 24 },
    { name: 'Full Floors', count: 17 },
    { name: 'Half Floors', count: 4 }
  ];
  cityList = configuration.cityList

  propertyForm: FormGroup;
  @ViewChild('priceFilter') priceFilter!: ElementRef;
  statuses: any[] = [
    { id: 0, name: 'Pending' },
    { id: 1, name: 'Approved' },
    { id: 2, name: 'Rejected' }
  ];
   priceOptions: string[] = [
     '100000', '200000', '300000', '400000', '500000',
    '600000', '700000', '800000', '900000', '1000000',
    '1500000', '2000000', '2500000', '3000000', '5000000', '10000000'
  ];
   isPriceFilterOpen: boolean = false; // Controls the visibility of the whole Min/Max box
  isMinDropdownOpen: boolean = false; // Controls the Min list visibility
  isMaxDropdownOpen: boolean = false; 
  emirateOptions = configuration.EMIRATES;
  hasMoreProperties: boolean = true;
  // emirateOptions = ['Abu Dhabi', 'Dubai', 'Sharjah', 'Ajman', 'Fujairah', 'Ras Al Khaimah', 'Umm Al Quwain'];
  // developerOptions = ['Developer 1', 'Developer 2', 'Developer 3'];


  searchWhere = {
    city: "",
    selling_type: "Buy",
    no_of_bedrooms: "",
    no_of_bathrooms: "",
    start_price: "",
    end_price: "",
    property_type_id: "",
    property_type_value: "",
    rental_period: "",
    min_price: "",
    max_price: "",
  }

  searchWhereActual: any = {
    city: "",
    selling_type: "1",
    no_of_bedrooms: "",
    no_of_bathrooms: "",
    start_price: "",
    end_price: "",
    property_type_id: "",
    property_type_value: "",
    bedroom_value: "",
    bathroom_value: "",
    rental_period: "",
    min_price: "",
    max_price: "",
    min_size: "",
    max_size: "",
    property_construction_type: "",
    sort_order: "created_at|DESC",
    amenities: [],
    furnishing_type: "",
    landmark: ""
  }

  selectedBedroom: any = {
    "1": false,
    "2": false,
    "3": false,
    "4": false,
    "5": false,
    "6": false,
    "7": false,
    "7+": false,
  };
  selectedBathroom: any = {
    "1": false,
    "2": false,
    "3": false,
    "4": false,
    "5": false,
    "6": false,
    "7": false,
    "7+": false,
  };

  cityCountRecords: any = [];
  landmarkCountRecords: any = [];
  cityId_param: any;
  propertyTypeId_param: any;
  noOfBedrooms_param: any;
  priceLimit_param: any;
  isParam: any = false;
  cityData: any = []
  tagValues: { label: any, value: any }[] = [];
  selectedTagItems: any = [];
  minPrice_param: any;
  maxPrice_param: any;
  isMyProperty: any = false
  userId: any

  lastSearch = "";
  lastSearchData = [];
  pageNumbers = [];

  amenitiesFilter = [
    "Central A/C",
    "Maids Room",
    "Balcony",
    "Shared Pool",
    "Shared Spa",
    "Shared Gym",
    "Concierge Service",
    "Covered Parking",
    "View of Water",
    "View of Landmark",
    "Pets Allowed",
    "Study",
    "Private Garden",
    "Private Pool",
    "Private Gym",
    "Private Jacuzzi",
    "Built-in Wardrobes",
    "Walk-in Closet",
    "Built-in Kitchen Appliances",
    "Maid Service",
    "Children's Play Area",
    "Children's Pool",
    "Barbecue Area",
  ];
  isSubmitted = false;
  myFormSubmit = false;
  isBrowser = false;
  isPriceDropdownOpen = false;

priceRanges = [
  { label: 'Below 50,000 AED', min: 0, max: 50000 },
  { label: '50,000 AED - 100,000 AED', min: 50000, max: 100000 },
  { label: '100,000 AED - 200,000 AED', min: 100000, max: 200000 },
  { label: 'Above 200,000 AED', min: 200000, max: null }
];
async loadMoreProperties() {
    this.currentPage++;
    this.offset = (this.currentPage - 1) * this.limit; 
    await this.getPropertyList(); 
  }

togglePriceDropdown() {
  this.isPriceDropdownOpen = !this.isPriceDropdownOpen;
}

selectPriceRange(range: any) {
  this.searchWhereActual.min_price = range.min;
  this.searchWhereActual.max_price = range.max;
  this.isPriceDropdownOpen = false;
}


  clearAll(): void {
    this.searchWhereActual.min_price = null;
    this.searchWhereActual.max_price = null;
    this.isMinDropdownOpen = false;
    this.isMaxDropdownOpen = false;
    this.applyFilter(); 
  }

  applyFilter(): void {
    console.log('Applying Filter:', this.searchWhereActual);
  }

  constructor(public shared: SharedService, private elRef: ElementRef, private renderer: Renderer2, public apiService: ApiServiceService, public router: ActivatedRoute, private route: Router, private fb: FormBuilder) {
    if (this.route.url.split("/")[1] == 'my-property-list') {
      if (this.shared.isBrowser()) {
        this.userId = this.shared.getLocalStorageValue(configuration.LOCAL_STORAGE.USER_ID);
      }
      this.isMyProperty = true
    }
    this.shared.isWhiteMenu = true;
    const sell_type: string = router.snapshot.params['sell_type'];
    const city: string = router.snapshot.params['city'];
    const type: string = router.snapshot.params['type'];
    console.log("type", type, router.snapshot.params)
    const no_of_bedrooms: string = router.snapshot.params['no_of_bedrooms'];

    if (no_of_bedrooms) {
      this.searchWhere.no_of_bedrooms = no_of_bedrooms;
      this.searchWhereActual.no_of_bedrooms = no_of_bedrooms;
      this.tagValues.push({
        label: no_of_bedrooms === '0' ? 'Studio' : `${no_of_bedrooms} BHK`,
        value: no_of_bedrooms
      });
    }
    if (sell_type) {
      this.searchWhere.selling_type = sell_type;
      if (sell_type != 'offplan') {
        this.searchWhereActual.selling_type = (sell_type == "rent" ? "2" : "1");
      } else if (sell_type == 'offplan') {
        this.searchWhereActual.selling_type = "1"
        this.searchWhereActual.property_construction_type = "2"
      }
    }
    if (city) {
      let city_id = this.findCityId(city)
      this.searchWhereActual.city_id = city_id
      this.searchWhere.city = city;
      this.searchWhereActual.city = city;

      this.tagValues.push({
        label: city,
        value: city_id
      })
    }
    if (type) {
      this.searchWhere.property_type_value = type;
      // this.searchWhereActual.property_type_value = type;      
    }
    this.propertyForm = this.fb.group({
      propertyName: [''],
      propertyStatus: [''],
      developerName: [''],
      location: [''],
      emirate: [''],
    });
  }
  togglePriceFilter(event: Event): void {
    // We already stop propagation on the main price filter box, but let's ensure the function closes others:
    this.isPriceFilterOpen = !this.isPriceFilterOpen;
    
    if (this.isPriceFilterOpen) {
        this.isPriceLimitRentDropdownOpen = false;
        this.isDropdownOpen = false;
        // Add any other mobile dropdowns/modals here
    }
    // You may also need to add event.stopPropagation() at the start of this function 
    // to prevent it from bubbling up to a global close handler, if one exists.
    if (event) {
        event.stopPropagation();
    }
}

  // Toggle Min dropdown
  toggleMinDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.isMinDropdownOpen = !this.isMinDropdownOpen;
    this.isMaxDropdownOpen = false;
  }

  // Toggle Max dropdown
  toggleMaxDropdown(event: MouseEvent) {
    event.stopPropagation();
    this.isMaxDropdownOpen = !this.isMaxDropdownOpen;
    this.isMinDropdownOpen = false;
  }

  // Select Min price
  selectMinPrice(price: string) {
    this.searchWhereActual.min_price = price === 'Min' ? '' : price;
    this.isMinDropdownOpen = false;
  }

  // Select Max price
  selectMaxPrice(price: string) {
    this.searchWhereActual.max_price = price === 'Max' ? '' : price;
    this.isMaxDropdownOpen = false;
  }
  isMobileFilterOpen: boolean = false;
  isMobileSortOpen: boolean = false;
toggleMobileFilter() {
  this.isMobileFilterOpen = !this.isMobileFilterOpen;
}
openSortModal() {
    // Toggle the visibility of the mobile sort options
    this.isMobileSortOpen = !this.isMobileSortOpen;
}
selectMobileSortOption(value: string) {
    // 1. Set the new sort value
    this.searchWhereActual.sort_order = value;
    
    // 2. Hide the modal/dropdown
    this.isMobileSortOpen = false;
    
    // 3. Re-run the search
    this.onFind(); 
}
getSortButtonLabel(): string {
    const currentSort = this.searchWhereActual.sort_order;
    switch (currentSort) {
        case 'is_featured|DESC': return 'Featured';
        case 'created_at|DESC': return 'Newest';
        case 'price|ASC': return 'Price (low)';
        case 'price|DESC': return 'Price (high)';
        case 'no_of_bedrooms|ASC': return 'Beds (least)';
        case 'no_of_bedrooms|DESC': return 'Beds (most)';
        default: return 'Sort';
    }
  }

  // Detect clicks outside the component
 @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    if (this.priceFilter && !this.priceFilter.nativeElement.contains(event.target)) {
      this.isPriceFilterOpen = false;
      this.isMinDropdownOpen = false;
      this.isMaxDropdownOpen = false;
    }
  }

  ngOnInit(): void {
    this.initPageData();
  }
  async initPageData() {
    this.isBrowser = this.shared.isBrowser();

    this.renderer.listen('document', 'click', (event: Event) => {
      const target = event.target as HTMLElement;
      if (!this.elRef.nativeElement.contains(target)) {
        // this.isDropdownOpen = false;
        // this.isPriceLimitDropdownOpen = false;
        this.isPriceLimitRentDropdownOpen = false;

      }
    });
    // this.getPropertyList();

    if (this.propertyTypeId_param) {
      await this.getTypeDetails()
    }

    if (this.noOfBedrooms_param) {
      this.selectedBedroom[this.noOfBedrooms_param] = !this.selectedBedroom[this.noOfBedrooms_param];
      this.searchWhereActual.bedroom_value = this.getSelectedRanges(this.selectedBedroom);
      if (this.searchWhereActual.bedroom_value) {
        if (this.searchWhereActual.bedroom_value == '1') {
          this.searchWhereActual.bedroom_value = this.searchWhereActual.bedroom_value += " Bed"
        } else {
          this.searchWhereActual.bedroom_value = this.searchWhereActual.bedroom_value += " Beds"
        }
      }
    }

    if (this.minPrice_param) {
      this.searchWhereActual.min_price = this.minPrice_param
    }

    if (this.maxPrice_param) {
      this.searchWhereActual.max_price = this.maxPrice_param
    }

    if (this.priceLimit_param) {
      this.searchWhereActual.min_price = '0'
      this.searchWhereActual.max_price = this.priceLimit_param
    }

    if (this.cityId_param) {
      await this.getCityList()
    }

    this.router.queryParams.subscribe(params => {
      if (params) {
        this.isParam = true
        this.cityId_param = params['city_id'];
        this.propertyTypeId_param = params['property_type'];
        this.noOfBedrooms_param = params['no_of_bedrooms'];
        this.priceLimit_param = params['price_limit'];

        this.minPrice_param = params['min_price'];
        this.maxPrice_param = params['max_price'];

        this.searchWhereActual.landmark = params['landmark'] ? params['landmark'] : "";
         this.searchWhereActual.property_type_id = params['property_type_id'] ? params['property_type_id'] : '';
        this.onFind();

        console.log("data", this.searchWhereActual);
        console.log("data", this.searchWhereActual.property_type_value);
        let title = this.shared.capitalizeFirstLetter(this.searchWhere.property_type_value) + " for ";
        if(this.searchWhereActual.selling_type == "2") {
          title += "rent ";
        } else {
          title += "sale ";
        }
        title += "in UAE";
        this.shared.setSEOData(title, {
          description: title + " | Direkt",
          url: environment.DOMAIN
        })
        console.log("title", title);

        // console.log('City ID:', this.cityId_param);
        // console.log('Property Type ID:', this.propertyTypeId_param);
        // console.log('No of Bedroom:', this.noOfBedrooms_param);
        // console.log('Price Limit:', this.priceLimit_param);
      }
    });
    this.getDeveloper();
  }

  async getTypeDetails() {
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_TYPE_DATA, {
      "id": this.propertyTypeId_param
    });
    if (res && !res.error && res.data) {
      this.searchWhere.property_type_value = res.data.property_type
      this.searchWhere.property_type_id = res.data.id
    }
  }

  async getCityList() {
    let arr = this.cityId_param.split(',')
    let res = await this.apiService.GET_apiRequest(configuration.ENDPOINT.CITY_LIST);
    if (res && !res.error && res.data && res.data.rows) {
      this.cityData = res.data.rows
      for (let i in this.cityData) {
        for (let j of arr) {
          if (j == this.cityData[i].id) {
            this.tagValues.push({
              label: this.cityData[i].city_name,
              value: this.cityData[i].id
            })
            if (!this.selectedTagItems.includes(this.cityData[i].id)) {
              this.selectedTagItems.push(this.cityData[i].id);
            }
          }
        }
      }
    }
  }


  async getPropertyList() {
    this.landmarkCountRecords = [];
    this.cityCountRecords = [];
    if (this.dropdownValues3 && this.dropdownValues3.length == 0) {
      let resCollection = await this.apiService.POST_apiRequest(configuration.ENDPOINT.COMMON_GET_DATA_BY_WHERE, {
        "collection": "masterPropertyType"
      });
      if (resCollection && !resCollection.error && resCollection.data && resCollection.data.rows) {
        this.dropdownValues3 = resCollection.data.rows;
        for (let t of this.dropdownValues3) {
          console.log(t.property_type, this.searchWhere);
          if (t.property_type.toLowerCase() == this.searchWhere.property_type_value) {
            this.searchWhere.property_type_id = t.id;
            this.searchWhereActual.property_type_id = t.id;
            this.searchWhereActual.property_type_value = t.property_type;
            break;
          }
        }
      }
    }

    let json: any = { ...this.searchWhereActual };
    json.limit = this.limit;
    json.offset = this.offset;

    if (this.isParam = true) {
      if (this.cityId_param) {
        json.city_id = this.cityId_param.split(',')
      }
      if (this.propertyTypeId_param) {
        json.property_type_id = this.propertyTypeId_param
      }
      if (this.noOfBedrooms_param) {
        json.no_of_bedrooms = this.noOfBedrooms_param
      }
      if (this.priceLimit_param) {
        json.price = this.priceLimit_param
      }

      if (this.minPrice_param) {
        json.min_price = this.minPrice_param
      }

      if (this.maxPrice_param) {
        json.max_price = this.maxPrice_param
      }
    }


    if (this.propertyForm.value.propertyName !== "") {
      json.property_name = this.propertyForm.value.propertyName;
    }
    if (this.propertyForm.value.propertyStatus !== "") {
      json.is_approve = this.propertyForm.value.propertyStatus;
    }
    if (this.propertyForm.value.developerName !== "") {
      json.developer_id = this.propertyForm.value.developerName;
    }
    if (this.propertyForm.value.location !== "") {
      json.address = this.propertyForm.value.location;
    }
    if (this.propertyForm.value.emirate !== "") {
      json.city_id = this.propertyForm.value.emirate;
    }


    json.isMyProperty = this.isMyProperty;
    console.log("json", this.isMyProperty)
    let suburl = configuration.ENDPOINT.PROPERTY_LIST;
    if (this.isMyProperty) {
      suburl = configuration.ENDPOINT.MY_PROPERTY_LIST;
    }
    this.shared.isLoader = true;
    this.searchWhereActual.landmark_id = 0;
    if (this.searchWhereActual.landmark) {
      let resLandmark = await this.apiService.POST_apiRequest(configuration.ENDPOINT.COMMON_GET_DATA_BY_WHERE, {
        "collection": "masterLandmark",
        "where": {
          landmark_name: this.searchWhereActual.landmark
        }
      });
      if (resLandmark && resLandmark.data && resLandmark.data.rows && resLandmark.data.rows[0]) {
        json.landmark_id = resLandmark.data.rows[0].id;
        this.searchWhereActual.landmark_id = json.landmark_id;
        let isLandmarkExists = false;
        for (let tv of this.tagValues) {
          if (tv.label == this.searchWhereActual.landmark) {
            isLandmarkExists = true;
            break;
          }
        }
        if (!isLandmarkExists) {
          this.tagValues = [];
          this.tagValues.push({
            label: this.searchWhereActual.landmark,
            value: json.landmark_id
          })
        }
      }
    }
    let res = await this.apiService.POST_apiRequest(suburl, json);
    this.shared.isLoader = false;

    if (res && !res.error && res.data) {
     if (this.currentPage === 1) {
    this.propertyList = res.data.rows;
  } else {
    this.propertyList = [...this.propertyList, ...res.data.rows];
  }
      this.pageNumbers = this.shared.getPageNumbers(res.data.count, this.limit);
      console.log("this.pageNumbers", this.pageNumbers);
      this.totalCount = res.data.count;
    }

    if(!this.isMyProperty) {
      if (this.searchWhereActual.city) {
        let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST_COUNT_LANDMARK, json);
        if (res && !res.error && res.data) {
          this.landmarkCountRecords = res.data;
        }
      } else {
        let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST_COUNT_CITY, json);
        if (res && !res.error && res.data) {
          this.cityCountRecords = res.data;
        }
      }
    }

    this.isLoaded = true;
  }

  ngAfterViewInit(): void {
    this.shared.includeMainScript();

    let self = this;
    let optionsPopover;
    if(this.shared.isBrowser()) {
      document.addEventListener("DOMContentLoaded", function () {

        const popoverPriceMainDiv = document.getElementById('popoverPriceMainDiv');
        const popoverTriggerEl = document.getElementById('popoverButton');
        if (popoverTriggerEl) {
          const popover = new bootstrap.Popover(popoverTriggerEl, {
            html: true, // Allows HTML content
            customClass: 'price-popover-box',
            container: "#popoverPriceMainDiv1",
            content: () => {
              // Define your custom HTML content here
              const divElement = document.createElement('div');
              divElement.innerHTML = `
              <div class='row'  style='width:400px'>
                <div class='col-6'>
                  <input type='text' id='popoverButtonMinPrice' value='${self.searchWhereActual.min_price}' class='form-control' placeholder='Min Price' data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" />
                </div>
                <div class='col-6'>
                  <input type='text' id='popoverButtonMaxPrice' value='${self.searchWhereActual.max_price}' class='form-control' placeholder='Max Price' data-bs-container="body" data-bs-toggle="popover" data-bs-placement="bottom" />
                </div>
                <div class='col-6 mt-2'>
                  <p class='pointer price-box-buttons' id="resetFilter">Reset Filter</p>
                </div>
                <div class='col-6 mt-2'>
                  <p class='pointer price-box-buttons' id="closeFilter">Close Filter</p>
                </div>
              </div>
              `;
              return divElement;
            }
          });
  
          const findButton = document.getElementById('findbtn');
          if (findButton) {
            findButton.addEventListener('click', () => {
              popover.hide(); // Hide the popover
            });
            if (optionsPopover) {
              optionsPopover.hide(); // Hide the options popover
            }
          }
  
          popoverTriggerEl.addEventListener('shown.bs.popover', () => {
  
            const resetFilterButton = document.getElementById('resetFilter');
            if (resetFilterButton) {
              resetFilterButton.addEventListener('click', () => {
                self.searchWhereActual.min_price = '';
                self.searchWhereActual.max_price = '';
                const minPriceInput = document.getElementById('popoverButtonMinPrice') as HTMLInputElement;
                const maxPriceInput = document.getElementById('popoverButtonMaxPrice') as HTMLInputElement;
                minPriceInput.value = '';
                maxPriceInput.value = '';
                if (optionsPopover) {
                  optionsPopover.hide(); // Hide the options popover
                }
              });
            }
  
            const closeFilterButton = document.getElementById('closeFilter');
            if (closeFilterButton) {
              closeFilterButton.addEventListener('click', () => {
                popover.hide(); // Hide the popover
                if (optionsPopover) {
                  optionsPopover.hide(); // Hide the options popover
                }
              });
            }
  
            document.addEventListener('click', (event: any) => {
              console.log("event.target", event.target, popoverTriggerEl.contains(event.target));
              if (!popoverTriggerEl.contains(event.target)) {
                if (optionsPopover) {
                  optionsPopover.hide(); // Hide the options popover
                }
              }
              if (!popoverPriceMainDiv.contains(event.target)) {
                if (popover) {
                  popover.hide(); // Hide the options popover
                }
              }
            });
  
  
  
            const popoverTriggerEl2: any = document.getElementById('popoverButtonMinPrice');
            if (popoverTriggerEl2) {
              const popover2 = new bootstrap.Popover(popoverTriggerEl2, {
                html: true, // Allows HTML content
                placement: "bottom",
                customClass: 'price-options-popover-box',
                container: "#popoverPriceMainDiv2",
                content: () => {
                  let optionsDiv = ``
                  let minPrice = 300000;
                  while (minPrice < 50000000) {
                    optionsDiv += `
                    <div class='eachOptionMin'>${minPrice} AED</div>
                    `
                    minPrice += 100000
                  }
                  // Define your custom HTML content here
                  const divElement = document.createElement('div');
                  divElement.innerHTML = `
                  <div class="col-12 bg-white">
                      <div class="form-group">
                          <div class="form-field">
                              <div class="select-wrap">
                                  <div class="custom-dropdown">
                                      <div class="options">
                                          ${optionsDiv}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  `;
                  return divElement;
                }
              });
  
              popoverTriggerEl2.addEventListener('shown.bs.popover', () => {
                optionsPopover = popover2;
                $(".price-options-popover-box").find(".eachOptionMin").click(function () {
                  self.searchWhereActual.min_price = parseInt($(this).html());
                  $("#popoverButtonMinPrice").val(self.searchWhereActual.min_price);
                  popover2.hide();
                });
              });
            }
  
            const popoverTriggerEl3: any = document.getElementById('popoverButtonMaxPrice');
            if (popoverTriggerEl3) {
              const popover2 = new bootstrap.Popover(popoverTriggerEl3, {
                html: true, // Allows HTML content
                customClass: 'price-options-popover-box',
                container: "#popoverPriceMainDiv3",
                content: () => {
                  // Define your custom HTML content here
                  let optionsDiv = ``
                  let minPrice: any = (self.searchWhereActual.min_price ? self.searchWhereActual.min_price : 300000);
                  while (minPrice < 50000000) {
                    optionsDiv += `
                    <div class='eachOptionMax'>${minPrice} AED</div>
                    `
                    minPrice += 100000
                  }
                  // Define your custom HTML content here
                  const divElement = document.createElement('div');
                  divElement.innerHTML = `
                  <div class="col-12 bg-white">
                      <div class="form-group">
                          <div class="form-field">
                              <div class="select-wrap">
                                  <div class="custom-dropdown">
                                      <div class="options">
                                          ${optionsDiv}
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  `;
                  return divElement;
                }
              });
  
              popoverTriggerEl3.addEventListener('shown.bs.popover', () => {
                optionsPopover = popover2;
                $(".price-options-popover-box").find(".eachOptionMax").click(function () {
                  self.searchWhereActual.max_price = parseInt($(this).html());
                  $("#popoverButtonMaxPrice").val(self.searchWhereActual.max_price);
                  popover2.hide();
                });
              });
            }
  
            popoverTriggerEl2.addEventListener('input', () => {
              self.searchWhereActual.min_price = popoverTriggerEl2.value;
              // console.log('Min Price:', self.minPrice);
            });
  
            // Event listener to get the max price
            popoverTriggerEl3.addEventListener('input', () => {
              self.searchWhereActual.max_price = popoverTriggerEl3.value;
              // console.log('Max Price:', self.maxPrice);
            });
  
          });
        }
      })
    }
  }
  onView() {
    this.isView = true;
  }
  onFilter() {
    this.isFilter = true;
  }
  onRemark() {
    this.isRemarkModal = true;
  }

  onViewRemark() {
    this.isViewRemarkModal = true

    // Do something with the selected user, for example, log it to the console
    // console.log('Clicked View Remark for user:', user);
  }
  closeRemarkModal() {
    this.isRemarkModal = false
  }

  closeViewRemarkModal() {
    this.isViewRemarkModal = false
  }

  closeViewModal() {
    this.isView = false
  }

  closeFilterModal() {
    this.isFilter = false
  }


  async onSubmit() {
    // this.myFormSubmit = true;
    // console.log(this.myForm.value)
    // let res = await this.apiServices.POST_apiRequest(configuration.ENDPOINT.CREATE_USER), {
    //   this.myForm.value
    // });
    // console.log("res", res);
    // if (res && !res.error) {
    //   this.isSubmitted = true;
  }
 toggleRentPriceLimitDropdown(): void {
    // 1. Toggle the current dropdown state
    this.isPriceLimitRentDropdownOpen = !this.isPriceLimitRentDropdownOpen;
    
    // 2. CRITICAL: Close all other related dropdowns to prevent conflicts
    if (this.isPriceLimitRentDropdownOpen) {
        this.isDropdownOpen = false;
        this.isPriceFilterOpen = false; // Assuming this is for price filter
        this.isMobileFilterOpen = false;
    }
}

  selectPriceLimitOption(option: string): void { // Updated type
    console.log("option", option);
    this.searchWhere.selling_type = option;
    this.searchWhereActual.selling_type = (option == "Rent" ? "2" : "1");
    this.isPriceLimitRentDropdownOpen = false;
  }

  onRentPriceDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.rent-dropdown');
    if (!dropdown.contains(event.target as Node)) {
      this.isPriceLimitRentDropdownOpen = false;
    }
  }

  toggleDropdown(): void {
    // 1. Toggle the current dropdown state
    this.isDropdownOpen = !this.isDropdownOpen;
    
    // 2. CRITICAL: Close all other related dropdowns
    if (this.isDropdownOpen) {
        this.isPriceLimitRentDropdownOpen = false;
        this.isPriceFilterOpen = false; // Assuming this is for price filter
        // Add any other mobile dropdowns/modals here
    }
}
  selectOption(option: any): void { // Updated type
    console.log("selectOption", option);
    // this.SelectedOption = option;
    this.searchWhere.property_type_value = option.property_type;
    this.searchWhere.property_type_id = option.id;
    this.searchWhereActual.property_type_value = option.property_type;
    this.searchWhereActual.property_type_id = option.id;
    this.isDropdownOpen = false;
  }
  @HostListener('document:click', ['$event'])
  onDocumentClick(event: any) {
    const clickedElement = event.target as HTMLElement;

    // Check if the clicked element is outside the dropdown
    if (!clickedElement.closest('.choose')) {
      this.isDropdownOpen = false;
      this.isPriceLimitRentDropdownOpen = false;
    }
  }

  isElectricityConnectionDropdownOpen: boolean = false;
  electricityConnectionSelectedOption: string = ''; // You may already have this property

  // Add these functions
  toggleElectricityConnectionDropdown(): void {
    this.isElectricityConnectionDropdownOpen = !this.isElectricityConnectionDropdownOpen;
  }

  selectMinSize(option): void {
    this.searchWhereActual.min_size = option;
    this.isElectricityConnectionDropdownOpen = false;
    this.dropdownValuesArea2 = [];
    for (let t of this.dropdownValuesArea) {
      if (t > this.searchWhereActual.min_size) {
        this.dropdownValuesArea2.push(t);
      }
    }
  }

  onElectricityConnectionDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.electricity-connection-dropdown');
    if (!dropdown.contains(event.target as Node)) {
      this.isElectricityConnectionDropdownOpen = false;
    }
  }

  isMaxAreaDropdownOpen: boolean = false;
  maxAreaSelectedOption: string = '';

  // Add these functions
  toggleMaxAreaDropdown(): void {
    this.isMaxAreaDropdownOpen = !this.isMaxAreaDropdownOpen;
  }

  selectMaxArea(option): void {
    this.searchWhereActual.max_size = option;
    this.isMaxAreaDropdownOpen = false;
  }

  selectMaxPriceOption(option: string): void {
    this.searchWhereActual.max_price = option;
    this.isMaxAreaDropdownOpen = false;
  }

  selectMinPriceOption(option: string): void {
    this.searchWhereActual.min_price = option;
    this.isMaxAreaDropdownOpen = false;
  }

  onMaxAreaDocumentClick(event: MouseEvent): void {
    const dropdown: any = document.querySelector('.max-area-dropdown');
    if (!dropdown.contains(event.target as Node)) {
      this.isMaxAreaDropdownOpen = false;
    }
  }

  selectBedroom(i: any) {
    this.selectedBedroom[i] = !this.selectedBedroom[i];
    this.searchWhereActual.bedroom_value = this.getSelectedRanges(this.selectedBedroom);
    if (this.searchWhereActual.bedroom_value == '1') {
      this.searchWhereActual.bedroom_value += " Bed"
    } else {
      this.searchWhereActual.bedroom_value += " Beds"
    }
  }

  selectBathroom(i: any) {
    this.selectedBathroom[i] = !this.selectedBathroom[i];
    this.searchWhereActual.bathroom_value = this.getSelectedRanges(this.selectedBathroom);
    if (this.searchWhereActual.bathroom_value == '1') {
      this.searchWhereActual.bathroom_value += " Bath"
    } else {
      this.searchWhereActual.bathroom_value += " Baths"
    }
  }

  clearBedBathVal() {
    this.searchWhereActual.bedroom_value = "";
    this.searchWhereActual.bathroom_value = "";
    let keys = Object.keys(this.selectedBathroom);
    for (let k of keys) {
      this.selectedBathroom[k] = false;
    }
    keys = Object.keys(this.selectedBedroom);
    for (let k of keys) {
      this.selectedBedroom[k] = false;
    }
  }

  selectAmenitiesFilter(af) {
    let index = this.searchWhereActual.amenities.indexOf(af);
    if (index == -1) {
      this.searchWhereActual.amenities.push(af)
    } else {
      this.searchWhereActual.amenities.splice(index, 1);
    }
  }

  clearAllFilter() {
    this.searchWhereActual.amenities = [];
    this.searchWhereActual.furnishing_type = "";
    this.searchWhereActual.min_size = "";
    this.searchWhereActual.max_size = "";
    this.onFind();
    this.isFilter = false;
  }

  getSelectedRanges(SBD: any) {
    const ranges = [];
    let start: any = null;

    let lastKey = "";
    Object.keys(SBD).forEach(key => {
      // const numericKey = +key; // Convert key to a number
      if (SBD[key]) {
        if (start === null) {
          // Start of a new range
          start = key;
        }
      } else {
        if (start !== null && lastKey != '') {
          // End of a range
          const end: any = lastKey;
          ranges.push(start === end ? start : `${start}-${end}`);
          start = null;
        }
      }
      lastKey = key;
    });

    // Handle the last range if it's still open
    if (start !== null) {
      const end = lastKey;
      ranges.push(start === end ? start : `${start}-${end}`);
    }

    return ranges.join(', ');
  }

  onAdded(event: any) {
    if (!this.selectedTagItems.includes(event.id)) {
      this.selectedTagItems.push(event.id);
    }
  }

  onDelete(event: any) {
    const index = this.selectedTagItems.indexOf(event.value);
    if (index !== -1) {
      this.selectedTagItems.splice(index, 1);
    }
  }

  onFind() {
    this.isFilter = false;
    this.getPropertyList()
  }

  getPriceLable() {
    return (this.searchWhereActual.min_price || this.searchWhereActual.max_price ?
      (this.searchWhereActual.min_price && this.searchWhereActual.max_price ? this.searchWhereActual.min_price + ' - ' + this.searchWhereActual.max_price :
        (this.searchWhereActual.min_price ? '>=' + this.searchWhereActual.min_price : ' <= ' + this.searchWhereActual.max_price)) : ' Price');
  }

  findCityId(cityName: any) {
    const city = this.cityList.find(city => city.name.toLowerCase() === cityName.toLowerCase());
    return city ? city.id : null;
  }

  requestAutocompleteItems = (text: string): Observable<any> => {
    // Prepare the data for the POST request
    if (this.lastSearch == text) {
      return of(this.lastSearchData);
    } else {
      this.lastSearch = text;
      const data = {
        "location": text
      };

      // Call the 'post' method from your ApiService
      // Note: The URL and other configurations should be handled inside your 'post' method
      return from(this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_LOCATION_DATA, data)).pipe(
        map(response => {
          this.lastSearchData = response;
          // Process the response here
          return response; // Adjust this according to your response structure
        }),
        catchError(error => {
          // Handle the error here
          console.error('Error fetching autocomplete items:', error);
          return throwError(() => new Error('Error fetching autocomplete items'));
        })
      );
    }

  };

  async changePage(p) {
    if (this.currentPage != p) {
      this.currentPage = p;
      this.offset = (this.currentPage - 1) * this.limit;
      await this.getPropertyList();
      window.scrollTo({
        top: 0,
        behavior: 'smooth' // Optional: Adds a smooth scrolling effect
      });
      console.log(p);
    }

  }

  nextPage() {
    if (this.currentPage < this.pageNumbers.length) {
      let page = this.currentPage + 1;
      this.changePage(page)
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      let page = this.currentPage - 1;
      this.changePage(page)
    }
  }

  async selectTab(tab): Promise<void> {
    this.selectedTab = tab;
    let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST, {});

    if (res && !res.error && res.data) {
      this.propertyList = res.data.rows;
    }

  }


  async onSubmitForm() {
    this.isSubmitted = true;
    this.getPropertyList();

    // console.log(this.propertyForm.value);

    // const filters = {
    //     property_name: this.propertyForm.value.propertyName || '',
    //     is_approve: this.propertyForm.value.propertyStatus || '',
    //     developer_id: this.propertyForm.value.developerName || '',
    //     address: this.propertyForm.value.location || '',
    //     city_id: this.propertyForm.value.emirate || ''
    // };

    // let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.PROPERTY_LIST, filters);

    // if (res && !res.error && res.data) {
    //     this.propertyList = res.data.rows; 
    // }
  }

  async getDeveloper() {
    const res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.GET_DEVELOPER_ALL, {});
    if (res && !res.error && res.data) {
      this.developerList = res.data; // Assuming res.data is an array of developers
    }
  }
}